<div class="container py-4">

  <!-- 🔷 TÍTULO -->
  <h2 class="titulo">LICENCIATURA EN GASTRONOMIA  </h2>

  <!-- 🟥 BANNER SUPERIOR -->
  <div class="banner-ia">

    <div class="banner-left">
      <img src="assets/banners_carreras/GASTRONOMIA.jpg" alt="IA"
      >
    </div>


  </div>


  <div class="badge-container">
    <img src="assets/banners_carreras/PROGRAMA-ACREDITADO.png" alt="Programa Educativo Acreditado" class="badge-img"   >
  </div>



  <!-- 📄 DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/folders/1ni3dhWAWShmhOCawamYz9zFn74jEcYdN" target="_blank" class="doc-link">
      ■ DOCUMENTACIÓN LICENCIATURA EN GASTRONOMIA
    </a>
  </div>


<section class="info-section">


  <div class="info-block">
    <h3>■ OBJETIVO GENERAL</h3>
    <p>
      Formar íntegramente profesionales de la gastronomía, con una visión de liderazgo, creatividad, sustentabilidad e innovación, que atiendan las necesidades pertinentes de su entorno social.
    </p>
  </div>

  <div class="info-block">
    <h3>■ MISION </h3>
    <p>
      Impulsar una formación multidisciplinaria de los y las estudiantes líderes con conocimiento y habilidades actualizadas que promueven su creatividad y competitividad para detectar y satisfacer las necesidades del sector gastronómico de la región, generando estrategias para el logro de los objetivos organizacionales, a través del capital humano de excelencia, permitiendo elevar su calidad de vida al impartir una educación integral.
    </p>
  </div>

  <div class="info-block">
    <h3>■  VISION </h3>
    <p>
      Ser la licenciatura en Gastronomía certificada con mayor reconocimiento en la región, destacada por su calidad académica y su cuerpo docente que contribuye a la formación de los gastrónomos(as) y administradores(as) restauranteros(as), capaces de desarrollar proyectos innovadores y de investigación; comprometidos éticamente para promover acciones que impulsen el cuidado del medio ambiente, el desarrollo social, cultural y económico a través de la gastronomía de nuestro país 
    </p>
  </div>

  <div class="info-block">
    <h3>■ PERFIL DE INGRESO  </h3>
   
      <ul>
        <li>Vocación de servicio.</li>
      
        <li>Capacidad para ejecutar recetas con calidad, higiene, creatividad y pasión a través de técnicas básicas culinarias en un tiempo establecido para satisfacer al cliente, con la visión de operar y administrar establecimientos de alimentos y bebidas.</li>
      
        <li>Tener capacidad de análisis, crítica e innovación.</li>
      
        <li>Actitud positiva hacia el cambio.</li>
      
        <li>Fuerte inclinación a la toma de decisiones.</li>
      
        <li>Habilidad para adaptarse al ambiente cultural internacional.</li>
      
        <li>Interés y respeto hacia otras culturas, e interés en desarrollar la actividad turística nacional.</li>
      
        <li>Trabajo bajo presión.</li>
      
        <li>Conocimientos en historia, geografía, sociología, matemáticas, química, inglés básico, vinos y licores, turismo, administración básica y gastronomía general.</li>
      </ul>
    
  </div>

</section>





</div>